import * as React from "react";
import type { SVGProps } from "react";
const SvgIcProducts = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#040747"
      fillRule="evenodd"
      d="M12.656 4.926a1.31 1.31 0 0 0-1.312 0L6.526 7.709l5.47 3.165 5.474-3.167zm-6.906 9.69V8.993l5.5 3.182v6.374l-4.843-2.796a1.31 1.31 0 0 1-.657-1.137m6.399 5.66a2.8 2.8 0 0 0 1.258-.374l4.937-2.85a2.82 2.82 0 0 0 1.406-2.436V8.913a2.81 2.81 0 0 0-1.407-2.434l-4.937-2.852a2.81 2.81 0 0 0-2.812 0L5.657 6.48A2.81 2.81 0 0 0 4.25 8.913v5.703c0 1.005.537 1.932 1.406 2.435l4.937 2.85c.39.227.822.35 1.258.374a.8.8 0 0 0 .297 0m.6-1.727v-6.378L18.25 8.99v5.627c0 .468-.25.901-.657 1.137z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIcProducts;
